module.exports = __webpack_public_path__ + "components/weather-icon/static/daypartcloud-3da8ddf288bc258517aff830b6899c17.webp";